// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__thGLr","productName":"Table_productName__uf0ib"};